import Config from '../../utils/Config';

var timerDelay = 4000;

class ProjectSlider extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            current : 0,
            timer   : false,
            uuid    : uuid()
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this.showSlide = this.showSlide.bind(this);
        this.calcHeight = this.calcHeight.bind(this);
    }

    componentDidMount() {
        var self = this;

        this.showSlide(0);

        this.setState({
            timer : setInterval(function() {
                self.showSlide(false)
            }, timerDelay)
        });

        var img = new window.Image();

        img.onload = () => {
            self.calcHeight()
        };

        img.src = Config.imgUrl()+'/public/codi-studios/projects/'+this.props.id+'/'+this.props.project.slides[0];

        $(window).resize(this.calcHeight);
    }

    componentWillUnmount() {
        $(window).off('resize', this.calcHeight);

        clearInterval(this.state.timer);
        this.setState({ timer : false });
    }

    calcHeight() {
        var imgWidth = $('#img_'+this.state.uuid+0).height();

        $('#'+this.state.uuid).css({
            'height' : imgWidth
        });

        console.log('CALC');
        if (this.props.project.title) {
            var w = $(window).width();
            var left = w / 2 - 500;
            var top = 80;

            console.log('CALC 2');

            if (left < 50)
                left = 50;

            if (w < 1000)
                top = 30;

            if (w < 764)
                top = 0;

            $('#'+this.state.uuid+' .project-slider__title').css({
                left : left,
                top : top,
            });
        }
    }

    showSlide(slide) {
        var self    = this;
        var slides = this.props.project.slides;

        var next = slide !== false ? slide : this.state.current + 1;

        if (next === slides.length) {
            next = 0;
        }

        this.setState({
            current : next
        }, function() {

            var prev = next - 1 < 0 ? slides.length - 1 : next - 1;

            $('#img_'+self.state.uuid+prev).css({ opacity : 0 });
            $('#img_'+self.state.uuid+next).css({ opacity : 1 });
        });
    }

    render() {
        var self = this;

        var project = this.props.project;
        var id = this.props.id;

        return (
            <div
                className='project-slider'
                id={this.state.uuid}>

                { project.title &&
                    <div className='project-slider__title'>
                        <h1>{project.title}<span>.</span></h1>
                    </div>
                }

                { project.slides.map((slide, i) => {
                    return (
                        <img
                            id={'img_'+self.state.uuid+i}
                            src={Config.imgUrl()+'/public/codi-studios/projects/'+id+'/'+slide}
                            key={'slider_'+self.state.uuid+i} />
                    );
                })}

            </div>
        );
    }
}

export default ProjectSlider;




// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectSlider.react.jsx